<template>
	<!-- 跟踪 -->
	<view class="trace-panel-box">
		<view class="nav_my_top">
			<view class="nav_my_order_all"> 
				<span style="font-size: 15px;" @click="announceInfo">查看全部</span>  
				<image :src="fnStaticRequestPath('icon/37.png')"
					class='go_to_icon'></image>
			</view>
			<text class="nav_my_top_tit">系统公告</text>
		</view>
		<view v-if="announceList != null && announceList.length > 0">
			<view class="Notice_list">
				<view v-for="(item, index) in announceList" :key="item.id">
					<view 
					class="Notice_list_li" 
					@click="handleClick(item)" 
					:style="item.isRead !== 0 ? { color: '#999999' } : {}">
					{{item.name}}
					</view>
				</view>
			</view>
		</view>
	</view>
</template>

<script setup>
	import {fnStaticRequestPath} from "../../utils/utils";
	import {getCurrentInstance, reactive, ref} from "vue";
	import * as util from "@/utils/utils";
	// 获取Vue实例上下文
	const {ctx} = getCurrentInstance();
	// defineProps接收父组件传输的数据
	const props = defineProps({
		// 公告列表数据
		announceList: {
			type: Array,
			required: true,
			default: () => []
		}
	})
	
	// 定义可以触发的事件
	const emit = defineEmits(['announce-click'])
	
	// 点击公告项处理事件
	const handleClick = (item) => {
		emit('announce-click', {
			id: item.id,
			isRead: item.isRead,
		})
	}
	
	// 公告跳转全部页面
	const announceInfo = () => {
		if(!ctx.vuex_hasLogin){
			uni.showToast({
			  title: '请登录后查看',
			  icon: 'none'
			})
			return
		}
		uni.navigateTo({
			url: '/pages/announceInfo/announceInfo',
			// url: '/pages/announceInfo/testPage',
			animationType: 'fade-in'
		});
	} 
</script>

<style lang="scss" scoped>
	
	.trace-panel-box {
		width:96%;
		margin:0 auto;
		border-radius: 10px;
		background-color: #ffffff;
		padding:10px;
		margin-top: 30px;
	}
	
	.nav_my_top{
		height: 70rpx;
		line-height: 70rpx;
		/* border-bottom: 1px solid #eff0f5; */
		padding: 0 10px;
	}
	
	.nav_my_order_all{
		float: right;
		font-size: 26rpx;
		color: #999999;
	}
	
	.nav_my_top_tit{
		color: #333;
		font-weight: bold;
		font-size: 16px;
	}
	
	.Notice_list {
		padding:15rpx 5rpx 25rpx;
		width:94%;
		display: block;
		margin: 0 auto;
	}
	
	.Notice_list_li {
		width:96%;
		font-size: 16px;
		color: #484848;
		margin-bottom: 10rpx;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.go_to_icon{
		width: 6px;
		height: 10px;
		margin-left: 10rpx;
		margin-bottom: 0rpx;
	}
</style>